import { Action as ReduxAction } from 'redux';

export enum ActionTypes {
  GET_WIDGETS_INIT = 'GET_WIDGETS_INIT',
  GET_WIDGETS_SUCCESS = 'GET_WIDGETS_SUCCESS',
  GET_WIDGETS_FAILURE = 'GET_WIDGETS_FAILURE',
  ADD_WIDGET = 'ADD_WIDGET_INIT',
  UPDATE_WIDGET = 'UPDATE_WIDGET_INIT',
  DELETE_WIDGET = 'DELETE_WIDGET_INIT',
  SET_ADD_WIDGET_NOTIFICATION = 'SET_ADD_WIDGET_NOTIFICATION',
  SAVE_WIDGETS_SUCCESS = 'SAVE_WIDGETS_SUCCESS',
  SAVE_WIDGETS_FAILURE = 'SAVE_WIDGETS_FAILURE',
  ON_WIDGET_RESIZE = 'ON_WIDGET_RESIZE',
  RESET_WIDGETS = 'RESET_WIDGETS',
  WINDOW_WIDTH_CHANGED = 'WINDOW_WIDTH_CHANGE',
  ON_DRAG_STOP = 'ON_DRAG_STOP',
  SAVE_WIDGETS_LAYOUT_TO_DB = 'SAVE_WIDGETS_LAYOUT_TO_DB',
  FETCH_USER_SETTINGS_INIT = 'FETCH_USER_SETTINGS_INIT',
  FETCH_USER_SETTINGS_SUCCESS = 'FETCH_USER_SETTINGS_SUCCESS',
  FETCH_USER_SETTINGS_FAILURE = 'FETCH_USER_SETTINGS_FAILURE',
}

export interface Action<Payload = null> extends ReduxAction<ActionTypes> {
  payload?: Payload;
}